export class DeclareExtraMissingDTO {
  constructor({ id } = {}) {
    this.id = id;
  }

  prepareAEData() {
    return {
      demandeId: this.id,
    };
  }

  prepareMERData() {
    return {
      demande_id: this.id,
    };
  }
}
